import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export async function esportaPDFSondaggio({ 
    sondaggio, 
    risposte, 
    dataInizioSondaggio, 
    dataFineSondaggio, 
    pdfElementRefs, 
    bannerInAlto = true // puoi aggiungere opzioni se vuoi
  }) {

    if (!sondaggio || !risposte) return;

        const doc = new jsPDF("p", "mm", "a4");
        const pageHeight = doc.internal.pageSize.height;
        const pageWidth = doc.internal.pageSize.width;
        const margin = 12; // Margine sinistro/destro
        const contentWidth = pageWidth - 2 * margin; // Larghezza utile
        let y = margin; // Posizione Y iniziale
    
        const pdfRefsMap = pdfElementRefs.current; // Usa il  ref
    
        // Funzione helper per gestire i cambi pagina
        const addPageIfNeeded = (neededHeight) => {
          if (y + neededHeight > pageHeight - margin) {
              doc.addPage();
              return margin; // Reset y to top margin
          }
          return y;
      };
    
      try {
        // --- PASSO 1: Calcola Altezza Totale Intestazione ---
        let totalHeaderHeight = 0;
        const tempDoc = new jsPDF("p", "mm", "a4"); // Usa un doc temporaneo per calcoli
        const centerX = pageWidth / 2;
    
        // Altezza Titolo
        tempDoc.setFontSize(25);
        tempDoc.setFont(undefined, 'bold');
        totalHeaderHeight += tempDoc.getTextDimensions(sondaggio.sonTitolo || 'Sondaggio', { fontSize: 16, fontStyle: 'bold' }).h + 6; // + spazio sotto
    
        // Altezza Descrizione
        tempDoc.setFontSize(16);
        tempDoc.setFont(undefined, 'normal');
        let descHeight = 0;
        if (sondaggio.sonDescrizione) {
            const descLines = tempDoc.splitTextToSize(sondaggio.sonDescrizione, contentWidth);
            descHeight = tempDoc.getTextDimensions(descLines).h;
            totalHeaderHeight += descHeight + 4; // + spazio sotto
        }
    
        // Altezza Periodo
        let periodoHeight = 0;
        if (dataInizioSondaggio && dataFineSondaggio) {
            const periodoText = `${new Date(dataInizioSondaggio).toLocaleDateString()} - ${new Date(dataFineSondaggio).toLocaleDateString()}`;
            periodoHeight = tempDoc.getTextDimensions(periodoText, { maxWidth: contentWidth }).h;
            totalHeaderHeight += periodoHeight + 10; // + spazio sotto
        } else {
            totalHeaderHeight += 10; // Spazio aggiunto anche se non c'è periodo
        }
    
        // Altezza Banner (richiede caricamento immagine)
        let bannerHeight = 0;
        if (sondaggio?.sonBanner && sondaggio?.sonBannerNome) {
            const ext = sondaggio.sonBannerNome.split(".").pop()?.toLowerCase();
            const mime = ext === "jpg" || ext === "jpeg" ? "image/jpeg" : "image/png";
            const bannerDataUrl = `data:${mime};base64,${sondaggio.sonBanner}`;
            const bannerImg = new Image();
            bannerImg.src = bannerDataUrl;
            try {
                await new Promise((resolve, reject) => {
                    bannerImg.onload = resolve;
                    bannerImg.onerror = reject; // Gestisci errore caricamento
                });
                bannerHeight = (bannerImg.height * contentWidth) / bannerImg.width;
                totalHeaderHeight += bannerHeight + 10; // + spazio sotto
            } catch (imgError) {
                console.error("Errore caricamento banner per calcolo altezza:", imgError);
                // Non aggiungere altezza banner se non si carica
            }
        }
        // Rimuovi l'ultimo spazio aggiunto se non c'è banner o se non si è caricato
        if (bannerHeight === 0) {
             if (periodoHeight > 0) totalHeaderHeight -= 10; // Rimuovi spazio dopo periodo
             else if (descHeight > 0) totalHeaderHeight -= 4; // Rimuovi spazio dopo descrizione
             else totalHeaderHeight -=6; // Rimuovi spazio dopo titolo
        }
    
    
        // --- PASSO 2: Calcola Y Iniziale per Centratura Verticale ---
        const availableHeight = pageHeight - 2 * margin;
        let startY = margin; // Default: inizia dal margine superiore
    
        if (totalHeaderHeight < availableHeight) {
            // Solo se l'altezza totale è minore dello spazio disponibile
            startY = margin + (availableHeight - totalHeaderHeight) / 2;
        }
        y = startY; // Imposta la y iniziale calcolata
    
        // --- PASSO 3: Disegna Effettivamente gli Elementi ---
    
        // Titolo
        doc.setFontSize(25);
        doc.setFont(undefined, 'bold');
        doc.text(sondaggio.sonTitolo || 'Sondaggio', centerX, y, { align: 'center' });
        y += doc.getTextDimensions(sondaggio.sonTitolo || 'Sondaggio', { fontSize: 16, fontStyle: 'bold' }).h + 6;
        doc.setFont(undefined, 'normal');
        doc.setFontSize(16);
    
        // Descrizione
        if (sondaggio.sonDescrizione) {
            // Usa l'altezza già calcolata 'descHeight'
            doc.text(sondaggio.sonDescrizione, centerX, y, { align: 'center', maxWidth: contentWidth });
            y += descHeight + 4;
        }
    
        // Periodo
        if (dataInizioSondaggio && dataFineSondaggio) {
            // Usa l'altezza già calcolata 'periodoHeight'
            const periodoText = `${new Date(dataInizioSondaggio).toLocaleDateString()} - ${new Date(dataFineSondaggio).toLocaleDateString()}`;
            doc.text(periodoText, centerX, y, { align: 'center', maxWidth: contentWidth });
            y += periodoHeight + 10;
        } else {
            y += 10; // Spazio aggiunto anche se non c'è periodo
        }
    
        // Banner
        if (bannerHeight > 0) { // Disegna solo se l'altezza è stata calcolata correttamente
             // Ricarica l'immagine o usa quella già caricata se l'hai salvata
             const ext = sondaggio.sonBannerNome.split(".").pop()?.toLowerCase();
             const mime = ext === "jpg" || ext === "jpeg" ? "image/jpeg" : "image/png";
             const bannerDataUrl = `data:${mime};base64,${sondaggio.sonBanner}`;
             // Non serve await qui se l'immagine è già stata caricata per il calcolo altezza
             doc.addImage(bannerDataUrl, mime.toUpperCase().replace('JPEG', 'JPG'), margin, y, contentWidth, bannerHeight);
             y += bannerHeight + 10;
        }
         // Rimuovi l'ultimo spazio se non c'era banner
         if (bannerHeight === 0) {
             if (periodoHeight > 0) y -= 10;
             else if (descHeight > 0) y -= 4;
             else y -=6;
        }
    
    
        // --- Cambio Pagina Forzato ---
        doc.addPage();
        y = margin; // Resetta y per la nuova pagina
    
          const allSectionsSorted = sondaggio.sezioni
                                        .sort((a, b) => a.sezPosizione - b.sezPosizione);
    
            for (const sezione of allSectionsSorted) {
    
                // ***** INIZIO: Aggiungi Titolo Sezione *****
                const sezioneTitle = `Sezione ${sezione.sezPosizione} - ${sezione.sezNome}`;
                doc.setFontSize(14); // Dimensione font per titolo sezione
                doc.setFont(undefined, 'bold'); // Grassetto per titolo sezione
                const titleHeightEst = doc.getTextDimensions(sezioneTitle, { maxWidth: contentWidth, fontSize: 14 }).h; // Stima altezza titolo
                const neededSpaceForTitle = titleHeightEst + 8; // Altezza titolo + spazio sotto
    
                y = addPageIfNeeded(neededSpaceForTitle); // Controlla se c'è spazio PRIMA di scrivere il titolo
    
                doc.text(sezioneTitle, margin, y, { maxWidth: contentWidth });
                y += titleHeightEst + 8; // Incrementa y DOPO aver scritto il titolo + spazio
    
                // Reimposta font per le domande (se necessario)
                doc.setFontSize(11); // O la dimensione che usi in DomandaGraficoPdfContent per h6
                doc.setFont(undefined, 'normal');
                // ***** FINE: Aggiungi Titolo Sezione *****
    
    
                const domandeOrdinate = sezione.domande
                                         .sort((a, b) => a.domNumPosizione - b.domNumPosizione);
    
                for (const domanda of domandeOrdinate) {
                    const elementToCapture = pdfRefsMap[`pdf-domanda-${domanda.domId}`];
    
                    if (elementToCapture) {
                        try {
                            await new Promise(resolve => setTimeout(resolve, 100)); // Delay
    
                            const scale = 2;
                            const canvas = await html2canvas(elementToCapture, {
                                scale: scale,
                                useCORS: true,
                                logging: false,
                                backgroundColor: '#ffffff',
                                scrollX: 0,
                                scrollY: -window.scrollY,
                                windowWidth: elementToCapture.scrollWidth,
                                windowHeight: elementToCapture.scrollHeight
                            });
                            const imgData = canvas.toDataURL("image/png", 1.0);
    
                            const imgProps = doc.getImageProperties(imgData);
                            const pdfImgWidth = contentWidth;
                            const pdfImgHeight = (imgProps.height * pdfImgWidth) / imgProps.width;
    
                            // Controlla spazio per l'immagine della domanda
                            y = addPageIfNeeded(pdfImgHeight + 10); // Spazio per immagine + margine sotto
    
                            doc.addImage(imgData, "PNG", margin, y, pdfImgWidth, pdfImgHeight);
                            y += pdfImgHeight + 10; // Spazio dopo l'immagine
    
                        } catch (canvasError) {
                            console.error(`Errore html2canvas per domanda ${domanda.domId}:`, canvasError);
                            const errorText = `D${domanda.domNumPosizione} - ${domanda.domDomanda} (Errore generazione grafico)`;
                            const errorHeight = doc.getTextDimensions(errorText, { maxWidth: contentWidth, fontSize: 10 }).h;
                            y = addPageIfNeeded(errorHeight + 5);
                            doc.setFontSize(10);
                            doc.setTextColor(255, 0, 0);
                            doc.text(errorText, margin, y, { maxWidth: contentWidth });
                            y += errorHeight + 5;
                            doc.setTextColor(0, 0, 0);
                            doc.setFontSize(11); // Reimposta dimensione font
                        }
                    } else {
                        console.warn(`Ref PDF non trovato per pdf-domanda-${domanda.domId}. Skipping in PDF.`);
                        const warningText = `D${domanda.domNumPosizione} - ${domanda.domDomanda} (Elemento non catturato)`;
                        const warningHeight = doc.getTextDimensions(warningText, { maxWidth: contentWidth, fontSize: 10 }).h;
                        y = addPageIfNeeded(warningHeight + 5);
                        doc.setFontSize(10);
                        doc.setTextColor(150, 150, 0);
                        doc.text(warningText, margin, y, { maxWidth: contentWidth });
                        y += warningHeight + 5;
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(11); // Reimposta dimensione font
                    }
                } // Fine loop domande
    
                // Aggiungi un po' di spazio extra tra la fine di una sezione e l'inizio della successiva (o la fine pagina)
                y += 5;
    
            } // Fine loop sezioni
    
            doc.save(`report_${sondaggio?.sonTitolo?.replace(/[^a-z0-9]/gi, '_') || 'sondaggio'}.pdf`);
    
        } catch (error) {
          console.error("Errore durante l'esportazione PDF:", error);
          // Mostra messaggio errore all'utente
        } finally {
        }
      };